import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, of, tap } from 'rxjs';
import {
    GetActionAssignmentOptions,
    GetActionItemOptions,
    GetActionTriggerOptions,
    GetActionTypeOptions,

} from './workflow.actions';
import { WorkflowService } from 'app/services/workflow/workflow.service';

export class WorkflowStateModel {
    actionTriggerOptions: any;
    actionTypeOptions: any;
    actionItemOptions: any[];
    actionAssignmentOptions: any[];
}

@State<WorkflowStateModel>({
    name: 'workflow',
    defaults: {
        actionTriggerOptions: [],
        actionTypeOptions: [],
        actionItemOptions: [],
        actionAssignmentOptions: [],
    }
})

@Injectable()
export class WorkflowState {

    @Selector()
    static actionAssignmentOptions(state: WorkflowStateModel) {
        return state.actionAssignmentOptions;
    }

    @Selector()
    static actionItemOptions(state: WorkflowStateModel) {
        return state.actionItemOptions;
    }

    @Selector()
    static actionTriggerOptions(state: WorkflowStateModel) {
        return state.actionTriggerOptions;
    }

    @Selector()
    static actionTypeOptions(state: WorkflowStateModel) {
        return state.actionTypeOptions;
    }

    constructor(
        private workflowService: WorkflowService,
    ) { }

    @Action(GetActionAssignmentOptions)
    getActionAssignmentOptions(
        { getState, patchState }: StateContext<WorkflowStateModel>,
        { actionItem, index }: GetActionAssignmentOptions
    ) {
        const ignoreThese = ['marketingEmailFlow', 'marketingSmsFlow', 'marketingEmailAndSmsFlow'];
        if (ignoreThese.includes(actionItem)) {
            return;
        }
        return this.workflowService.getCriteriaOptions(actionItem).pipe(
            catchError(err => {
                return of();
            }),
            tap(actionAssignmentOptions => {
                const assignments = getState().actionAssignmentOptions;
                assignments[index] = actionAssignmentOptions;
                patchState({ actionAssignmentOptions: assignments });
            })
        );
    }

    @Action(GetActionItemOptions)
    getActionItemOptions(
        { getState, patchState }: StateContext<WorkflowStateModel>,
        { actionType, index }: GetActionItemOptions
    ) {
        return this.workflowService.getCriteriaOptions(actionType).pipe(
            catchError(err => {
                return of();
            }),
            tap(actionItemOptions => {
                const actionItems = getState().actionItemOptions;
                actionItems[index] = actionItemOptions;
                patchState({ actionItemOptions: actionItems });
            })
        );
    }

    @Action(GetActionTriggerOptions)
    getTriggerOptions(
        { patchState }: StateContext<WorkflowStateModel>
    ) {
        return this.workflowService.getCriteriaOptions('trigger').pipe(
            catchError(err => {
                return of();
            }),
            tap(actionTriggerOptions => {
                patchState({ actionTriggerOptions });
            })
        );
    }

    @Action(GetActionTypeOptions)
    getActionTypeOptions(
        { patchState }: StateContext<WorkflowStateModel>
    ) {
        return this.workflowService.getCriteriaOptions('actionType').pipe(
            catchError(err => {
                return of();
            }),
            tap(actionTypeOptions => {
                patchState({ actionTypeOptions });
            })
        );
    }
}

